const LEGACY_KEY_PREFIX = 'sent-relances:';

// Removes the per-tenant sent-relance entries (customer names, amounts, notes) left in localStorage.
export const purgeLegacySentRelanceCache = (): void => {
    try {
        Object.keys(localStorage)
            .filter(key => key.startsWith(LEGACY_KEY_PREFIX))
            .forEach(key => localStorage.removeItem(key));
    } catch {
        // Storage unavailable: nothing was persisted to purge.
    }
};
